<template>
	<v-col class="add-message">
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Buat Pesan</div>
		</div>
		<div class="pt-1 pb-2 d-flex flex-wrap font-size-10 grey--text">
			<v-icon small color="grey">mdi-email</v-icon>
			<div class="pl-2">Pesan</div>
			<div class="px-2">/</div>
			<div>Buat Pesan</div>
		</div>
		<div class="mt-5">
			<v-row>
				<v-col cols="12">
					<div class="font-size-11 cl-grey">Tujuan Pesan</div>
					<v-radio-group class="mt-2" v-model="destination" row hide-details="auto">
						<v-radio label="Mitra" value="mitra" @click="selectDestination"></v-radio>
						<v-radio label="Admin" value="admin" @click="selectDestination"></v-radio>
					</v-radio-group>
				</v-col>
				<v-col cols="12" v-if="false">
					<v-autocomplete solo placeholder="Penerima" prepend-inner-icon="mdi-account" append-icon="" class="rounded-lg" hide-no-data hide-details="auto" v-model="receiver" :items="memberSearchList" :loading="isLoading" :search-input.sync="search" item-text="member_data" item-value="member_network_code">
					</v-autocomplete>
				</v-col>
				<v-col cols="12" v-if="destination == 'mitra'">
					<v-text-field solo placeholder="Kode Mitra" prepend-inner-icon="mdi-account" append-icon="" class="rounded-lg" hide-details="auto" v-model="receiver"></v-text-field>
				</v-col>
				<v-col cols="12" v-if="destination == 'admin'">
					<v-text-field solo placeholder="Penerima" prepend-inner-icon="mdi-account" append-icon="" class="rounded-lg" hide-details="auto" v-model="receiver" readonly></v-text-field>
				</v-col>
				<v-col cols="12" class="pt-0">
					<v-card class="rounded-lg elevation-0">
						<wysiwyg placeholder="Isi Pesan" v-model="content" />
					</v-card>
					<div class="pt-2 pb-1 font-size-10 cl-grey" v-if="content.length < 10">Isi Pesan minimal 10 karakter</div>
					<div class="pt-2 pb-1 font-size-10 cl-grey" v-if="content.length > 500">Isi Pesan maksimal 500 karakter</div>
				</v-col>
				<v-col cols="12" class="pt-0 text-right">
					<v-btn depressed color="primary" class="white--text rounded-xl text-capitalize" :disabled="!checkData" :loading="btnLoading" @click="processMessage">
						<div class="d-flex">
							<v-icon small>mdi-send</v-icon>
							<div class="pl-2">Kirim</div>
						</div>
					</v-btn>
				</v-col>
			</v-row>
		</div>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
	components: {
	},
	data() {
		return {
			destination: 'mitra',
			receiver: null,
			content: '',
			isLoading: false,
			model: null,
			search: null,
			memberSearchList: [],
			btnLoading: false,
		}
	},
	computed: {
		...mapState('message', ['autocompleteMessage']),

		checkData() {
			if ( this.receiver && this.content && this.content.length >= 10) {
				return true
			} else {
				return false
			}
		}
	},
	methods: {
		...mapActions('message', ['getAutocomplete', 'addMessage', 'addMessageAdmin']),

		customFilterMember(item, queryText) {
			const textOne = item.member_name.toLowerCase()
			const textTwo = item.member_network_code.toLowerCase()
			const searchText = queryText.toLowerCase()

			return textOne.indexOf(searchText) > -1 ||
			textTwo.indexOf(searchText) > -1
		},
		checkRouter() {
			if (this.$route.params.code) {
				this.receiver = this.$route.params.code
			}
		},
		selectDestination() {
			if( this.destination == 'admin' ) {
				this.receiver = 'Admin'
			}
			else {
				if (this.$route.params.code) {
					this.receiver = this.$route.params.code
				} else {
					this.receiver = ''
				}
			}
		},
		processMessage() {
			if (this.destination == 'mitra') {
				let params = {message_network_code: this.receiver, message_content: this.content}
				this.btnLoading = true
				this.addMessage(params).then(() => {
					this.btnLoading = false
					this.receiver = null
					this.content = ''
					this.memberSearchList = []
				}).catch(() => {
					this.btnLoading = false
				})
			} else {
				let params = {message_content: this.content}
				this.btnLoading = true
				this.addMessageAdmin(params).then(() => {
					this.btnLoading = false
					this.content = ''
					this.memberSearchList = []
				}).catch(() => {
					this.btnLoading = false
				})
			}
		},
	},
	watch: {
		search(val) {
			if (!this.search)
				return
			if (val.length == 3) {
				if (this.isLoading)
					return

				this.isLoading = true

				this.getAutocomplete({search: val}).then(() => {
					this.memberSearchList = this.autocompleteMessage
					this.memberSearchList.map(entry => {
						return Object.assign({}, entry)
					})
				}).catch(() => {
					this.memberSearchList = []
				}).finally(() => (this.isLoading = false))
			}
			if (val.length <= 2) {
				this.memberSearchList = []
			}
		},
	},
	created(){
		this.$store.dispatch('setPageTitle', `Buat Pesan`)
		this.checkRouter()
	}
};
</script>
